import {match} from 'ts-pattern';

import {openNewTab} from './openNewTab';

export const openAdLink = (originalUrl: string, market: string, language: string) => {
  const url = match<{market: string; language: string}, string>({market, language})
    .with({market: 'BEL', language: 'nl'}, () =>
      originalUrl.replace('autoscout24.de/angebote/', 'autoscout24.be/nl/aanbod/')
    )
    .with({market: 'BEL', language: 'fr'}, () =>
      originalUrl.replace('autoscout24.de/angebote/', 'autoscout24.be/fr/offres/')
    )
    .with({market: 'BEL', language: 'en'}, () =>
      originalUrl.replace('autoscout24.de/angebote/', 'autoscout24.be/fr/offres/')
    )
    .otherwise(() => originalUrl);

  openNewTab(url);
};
